const body = document.getElementById('body');
const toggle = document.getElementById('menu-toggle');
const hamburger = toggle.querySelector('.hamburger');
const mobileMenu = document.getElementById('mobile-menu');

// Mobile Menu Toggle
if (toggle) {

    toggle.addEventListener('click', () => {
        hamburger.classList.toggle('active');
        mobileMenu.classList.toggle('active');
        body.classList.toggle('overflow-hidden')
    });

}

// Menu Items with Children
const menuItemsWithChildren = mobileMenu.querySelectorAll('.menu-item-has-children > a');

if (menuItemsWithChildren) {

    menuItemsWithChildren.forEach((item) => {
        // TODO: Incredibly hacky DOM manipulation - replace the custom navwalker
        const wrapper = document.createElement('div');
        wrapper.classList.add('toggle-container');
        item.parentNode.insertBefore(wrapper, item);
        wrapper.appendChild(item);
        wrapper.innerHTML += `
            <button class='toggle-submenu'>
                <span class="line"></span>
                <span class="line"></span>
                <span class='sr-only'>Open Sub Menu</span>
            </button>
        `;
    });

}

// Add Functionality to toggle buttons
const toggleButtons = document.querySelectorAll('.toggle-submenu');

if (toggleButtons) {

    toggleButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            const contextualSubmenu = btn.parentElement.parentElement.querySelector('.sub-menu');

            btn.classList.toggle('active');
            contextualSubmenu.classList.toggle('active');
        })
    });

}
